import ReactDOM from "react-dom/client";

import "stream-chat-react/dist/css/v2/index.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "react-modern-drawer/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import "./date-picker-overrides.css";

import App from "./App";

import { pdfjs } from "react-pdf";
import { StrictMode } from "react";

pdfjs.GlobalWorkerOptions.workerSrc = `/modules/pdfjs-dist@5_4_296.mjs`;

const root = ReactDOM.createRoot(document.getElementById("root") as Element);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
